/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { RecommendWorkTypesRequestDto } from '../model/recommendWorkTypesRequestDto';
// @ts-ignore
import { SearchWorkTypesResponseDto } from '../model/searchWorkTypesResponseDto';
// @ts-ignore
import { WorkTypeRecommendationResponseDto } from '../model/workTypeRecommendationResponseDto';
// @ts-ignore
import { WorkTypesControllerList200Response } from '../model/workTypesControllerList200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkTypesService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Get work type by ID
   * @param id Work type identifier
   * @param expand Fields to expand in the response
   */
  public async workTypesControllerGetById(id: string, expand?: Array<'groups'>, ): Promise<WorkTypesControllerList200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling workTypesControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-types/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-types/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List all work types
   * @param expand Fields to expand in the response
   */
  public async workTypesControllerList(expand?: Array<'groups'>, ): Promise<WorkTypesControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-types?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-types`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get recommended work types for a patient
   * @param recommendWorkTypesRequestDto 
   */
  public async workTypesControllerRecommendWorkTypes(recommendWorkTypesRequestDto: RecommendWorkTypesRequestDto, ): Promise<Array<WorkTypeRecommendationResponseDto>> {
    if (recommendWorkTypesRequestDto === null || recommendWorkTypesRequestDto === undefined) {
      throw new Error('Required parameter recommendWorkTypesRequestDto was null or undefined when calling workTypesControllerRecommendWorkTypes.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-types/recommend`,
        data: recommendWorkTypesRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search work types
   * @param q Search query string
   * @param page Page number (1-based)
   * @param limit Results per page
   * @param expand Fields to expand in the response
   */
  public async workTypesControllerSearch(q: string, page?: number, limit?: number, expand?: Array<'groups'>, ): Promise<SearchWorkTypesResponseDto> {
    if (q === null || q === undefined) {
      throw new Error('Required parameter q was null or undefined when calling workTypesControllerSearch.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (q !== undefined && q !== null) {
      localVarQueryParameters.append('q', String(q));
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters.append('page', String(page));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-work-management/work-types/search?${queryString}` : `${this.configuration.basePath}/api/forthbridge-work-management/work-types/search`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
